import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Spin } from "antd";

import CommentEach from "./CommentEach";

const ChannelCommentList = ({
	type,
	total,
	commentList,
	getCommentList,
	getFindComment,
	comLoading,
	setComLoading,
	findComment,
	setFindComment,
	currentPageNumber,
}) => {
	const [showId, setShowId] = useState(null);
	const cUser = useSelector((state) => state.auth.channelUser);
	return (
		<div
			className={`comment-list-div`}
			style={
				!cUser?.id
					? {
							filter: "blur(7px)",
					  }
					: {}
			}
		>
			<div className={`comment-list-row`}>
				<p>총 {total ?? 0}개</p>
				<p>최신순</p>
			</div>

			{/* 댓글 */}
			{comLoading && (
				<Spin
					style={{
						margin: "auto",
						width: "100%",
						paddingTop: "2em",
						position: "absolute",
						left: 0,
						right: 0,
					}}
				/>
			)}
			<div className={`comment-list-column`}>
				{commentList?.map((comment, index) => (
					<div
						className={`comment-each`}
						id={`comment-${index}`}
						key={`comment-each-by-list-${index}`}
					>
						<CommentEach
							type={type}
							comment={comment}
							index={index}
							getCommentList={getCommentList}
							getFindComment={getFindComment}
							comLoading={comLoading}
							setComLoading={setComLoading}
							showId={showId}
							setShowId={setShowId}
							findComment={findComment}
							currentPageNumber={currentPageNumber}
							setFindComment={setFindComment}
						/>
					</div>
				))}
			</div>
		</div>
	);
};
export default ChannelCommentList;
